import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import cn from "classnames";
import styles from "./Page.module.sass";
import Sidebar from "../Sidebar";

const MOBILE_QUERY = "(max-width: 767px)";

const Page = ({ wide, children, isPadding = true, noVerticalPadding = false, title }) => {
  const [visible, setVisible] = useState(false);
  // En movil el sidebar es un drawer y nunca se renderiza colapsado: el estado
  // collapsed persistido de escritorio no debe filtrarse al layout movil.
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_QUERY).matches);
  const [collapsed, setCollapsed] = useState(() => {
    try {
      const saved = localStorage.getItem('sidebarCollapsed');
      if (saved !== null) return saved === 'true';
    } catch {}
    return window.innerWidth <= 1259;
  });

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener ? mq.addEventListener("change", onChange) : mq.addListener(onChange);
    return () => {
      mq.removeEventListener ? mq.removeEventListener("change", onChange) : mq.removeListener(onChange);
    };
  }, []);

  const handleSetCollapsed = (val) => {
    setCollapsed(val);
    try {
      localStorage.setItem('sidebarCollapsed', String(val));
    } catch {}
  };

  return (
    <div className={cn(styles.page, { [styles.collapsed]: collapsed })} data-sidebar-collapsed={collapsed}>
      <div
        className={cn(styles.overlay, { [styles.overlayVisible]: visible })}
        onClick={() => setVisible(false)}
        aria-hidden="true"
      />
      <Sidebar
        className={cn(styles.sidebar, { [styles.visible]: visible })}
        onClose={() => setVisible(false)}
        collapsed={collapsed && !isMobile}
        setCollapsed={handleSetCollapsed}
      />
      <div className={cn(styles.inner, !isPadding && styles.noPadding, noVerticalPadding && styles.noVerticalPadding)}>
        <button className={styles.mobileMenu} onClick={() => setVisible(true)}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <div
          className={cn(styles.container, {
            [styles.wide]: wide,
          })}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default withRouter(Page);
